import * as React from 'react';
import { memo } from 'react';
import TerrificBridge from 'react-terrific-bridge';

import withLayout from 'components/hoc/withLayout';
import { WithLayoutPropsType } from 'components/hoc/withLayout';
import guid from 'helper/guid';

import OverlayTemplate from 'components/molecules/Overlay/Template';
import { createRef } from 'react';

type OverlayProps = {
	id?: string;
	reactId?: string;
	closable: boolean;
	closeButton?: boolean;
	contentStyle?: string;
	children?: React.ReactNode;
	isOpen: boolean;
	onClose?: Function;
	preventLock?: boolean;
	animation?: string;
	preventUnlock?: boolean;
};

type OverlayWithLayoutProps = OverlayProps & WithLayoutPropsType;

export class Overlay extends React.Component<OverlayWithLayoutProps> {
	public static displayName = 'Overlay';
	public static defaultProps = {
		closable: false,
		closeButton: false,
		isOpen: false,
		onClose: () => {
			/* noop */
		},
	};

	public instanceId = `overlay_${this.guid}`;

	private componentRef: React.RefObject<HTMLDivElement>;

	constructor(props: OverlayWithLayoutProps) {
		super(props);
		this.componentRef = createRef();
	}

	get guid(): string {
		return guid();
	}

	public componentDidMount() {
		TerrificBridge.registerComponent(this.componentRef.current, {
			clearOverlay: this.props.onClose!.bind(this),
		});
	}

	public componentWillUnmount() {
		TerrificBridge.unregisterComponent(this.componentRef.current);
	}

	public componentDidUpdate(prevProps: OverlayProps) {
		if (!prevProps.isOpen && this.props.isOpen === true) {
			TerrificBridge.action(this.componentRef.current, 'open');
		}

		if (prevProps.isOpen && this.props.isOpen === false) {
			TerrificBridge.action(this.componentRef.current, 'close');
		}
	}

	public render() {
		const { id, closable, contentStyle, children } = this.props;
		const overlayId: string = id || this.instanceId;
		let wrapperProps: {
			className: string;
			'data-t-name': string;
			'data-overlay': string;
			'data-closable'?: string;
		} = {
			className: 'm-overlay lity-hide',
			'data-t-name': 'Overlay',
			'data-overlay': `#${overlayId}`,
		};

		if (closable) {
			wrapperProps = { ...wrapperProps, 'data-closable': closable.toString() };
		}

		return (
			<div ref={this.componentRef} {...wrapperProps}>
				<OverlayTemplate {...this.props} />
				<div
					id={`${overlayId}`}
					className={`m-overlay__content${contentStyle ? ` m-overlay__content--${contentStyle}` : ''}`}
				>
					{children}
				</div>
			</div>
		);
	}
}

export default memo(withLayout(Overlay) as any, (prevProps, nextProps) => {
	return (
		prevProps.reactId === nextProps.reactId &&
		prevProps.isOpen === nextProps.isOpen &&
		prevProps.children === nextProps.children
	);
});
